<template>
   <v-container>
        <div class="text-left" style="margin-bottom:20px;">
            <router-link to="/uk">
                <v-btn
                    color="secondary"
                    class="text-right"
                    style="width:250px"
                >
                    Back
                </v-btn>
            </router-link>
        </div>           
      <v-row>
        <v-col cols="12" class="text-left">
          <h1>February 4</h1>
          <p>Scotland</p>
          <p>Knipoch House Hotel</p>
          <img alt="Knipoch House Hotel View" class="uitk-image-media" src="/uk/04Knipoch2.jpeg" style="width: 17%; height: auto;">      
          <img alt="Knipoch House Hotel" class="uitk-image-media" src="/uk/04Knipoch.jpeg" style="width: 17%; height: auto;">      
          <img alt="breakfast" class="uitk-image-media" src="/uk/04Breakfast.jpeg" style="width: 17%; height: auto;">   
          <p></p>
          <p>Edinburgh</p>
          <img alt="Edinburgh Castle" class="uitk-image-media" src="/uk/04EdinburghCastle.jpeg" style="width: 17%; height: auto;">      
          <img alt="Edinburgh Castle" class="uitk-image-media" src="/uk/04EdinburghCastle2.jpeg" style="width: 17%; height: auto;">    
          <p>Me kilt was blowing up in one of those photos!</p>
          <p>A big drive through 3 contries, Scotland, England and then Wales!</p>
        </v-col>
      </v-row>
    </v-container>
  </template>
  
  <script>
  
  //vue 3 style
  import { ref } from 'vue'
  
  export default {
    name: 'HomeView',
    setup() {
    }
  }
  </script>